import React, {useEffect, useState} from 'react';
import '../../styles/reports.css';
import Viewer from '../../components/Reports/ReportViewer';
import ReportList from '../../components/Reports/ReportList';
import {get} from '../../service/ApiService';
import {Report} from '../../service/Urls';
import {useToast} from '@chakra-ui/react';
import {useLocation} from 'react-router-dom';

/* Pass a report name to this by using either a react-router Link, useNavigation or ButtonLink (components/general/ButtonLink)
 * pass a state with the parameter name reportName ie. navigate('/reports/viewer',{state:{reportName:'Status report'});
 * https://stackoverflow.com/questions/64566405/react-router-dom-v6-usenavigate-passing-value-to-another-component
 */
const PrintReports = props => {
  const location = useLocation();
  const [selectedReport, setSelected] = useState('');
  const [reportList, setReportList] = useState([]);

  // useEffect(() => {
  //   console.log('ummmmmm');
  //   populateReports();
  // }, []);

  // async function populateReports() {
  //   const reports = await get(Report.LIST);
  //   if (reports?.error) {
  //     toast({
  //       title: 'Error',
  //       description: reports.error,
  //       status: 'error',
  //       duration: 9000,
  //       isClosable: true,
  //     });
  //   } else {
  //     setSelected(reports[0]);
  //     setReportList(reports);
  //   }
  // }

  // const selectReport = reportName => {

  //   setSelected(reportName);
  // };

  return (
    <div className="main">
      {/* <ReportList items={reportList} selectedReport={selectedReport} selectReport={selectReport} /> */}
      <Viewer reportName={location.state.reportName} reportParams={location.state.reportParams ? location.state.reportParams : {}} />
    </div>
  );
};

export default PrintReports;
